import Vue from 'vue';
import 'normalize.css';
import { Row, Col, Form, FormItem, Input, Select, Option } from 'element-ui';
import Vue2TouchEvents from 'vue2-touch-events';
import VueCarousel from 'vue-carousel';
import Velocity from 'velocity-animate';
import VueFullPage from 'vue-fullpage.js';

import App from './App.vue';
import router from '@/router';
import store from '@/store';
import '@/styles/global.scss';
import 'fullpage.js/dist/fullpage.min.css';

// Element UI
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);

// Vue touch events
Vue.use(Vue2TouchEvents);

// Vue carousel
Vue.use(VueCarousel);

// Use Fullpage to deal with scrolling
Vue.use(VueFullPage);

// Velocity for animation
Vue.prototype.$Velocity = Velocity;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
